import { inject, NewInstance, BindingEngine } from 'aurelia-framework';
import { CustomerProjectService } from 'pages/standard-setup/customer-projects/service';
import { CustomerService } from 'pages/quote-setup/customers/service';
import { ProjectService } from 'pages/quote-setup/projects/service';
import { PlantService } from 'pages/quote-setup/plants/service';
import { StandardService } from 'pages/standard-setup/standards/service';
import { UnitOfMeasurementService } from 'pages/system-fields/unit-of-measurements/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { DialogService } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), CustomerProjectService, EventAggregator, DialogService, CustomerService, ProjectService, PlantService, UnitOfMeasurementService, StandardService, BindingEngine)
export class CustomerProjectEditor {
    constructor(controller, validationController, customerProjectService, ea, dialogService, customerService, projectService, plantService, unitOfMeasurementService, standardService, bindingEngine) {
        this.controller = controller;
        this.customerProjectService = customerProjectService;
        this.ea = ea;
        this.dialogService = dialogService;
        this.customerService = customerService;
        this.projectService = projectService;
        this.plantService = plantService;
        this.standardService = standardService;
        this.unitOfMeasurementService = unitOfMeasurementService;
        this.customerProject = {
            weldingStandardId: null,
            stampingStandardId: null
        };

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('customerId').required()
            .ensure('projectId').required()
            .ensure('plantId').required()
            .ensure('weldingStandardId').required()
            .ensure('stampingStandardId').required()
            .rules;

        bindingEngine.propertyObserver(this.customerProject, 'weldingStandardId')
            .subscribe(async (newValue, oldValue) => {
                if (newValue != null) {
                    this.configs = await this.standardService.getConfigsByNumberId(newValue);
                    if (!this.configs.some(x => x.workCenter === 'WELDING')) {
                        toastr.error('Selecting standard does not have a welding standard');
                        this.weldingSelect.clearSelection();
                    }
                }
            });

        bindingEngine.propertyObserver(this.customerProject, 'stampingStandardId')
            .subscribe(async (newValue, oldValue) => {
                if (newValue != null) {
                    this.configs = await this.standardService.getConfigsByNumberId(newValue);
                    if (!this.configs.some(x => x.workCenter === 'STAMPING')) {
                        toastr.error('Selecting standard does not have a stamping standard');
                        this.stampingSelect.clearSelection();
                    }
                }
            });
    }

    async activate(model) {
        if (model?.id != null) {
            this.customerProject = await this.customerProjectService.getById(model.id);
        }
        else {
          if (model) {
            this.customerProject = model;
          }
        }
        
    }

 

    addCustomer() {
        this.dialogService.open({ viewModel: this.customerService.editor });
    }

    addProject() {
        this.dialogService.open({ viewModel: this.projectService.editor });
    }

    addPlant() {
        this.dialogService.open({ viewModel: this.plantService.editor });
    }

    addUnitOfMeasurement() {
        this.dialogService.open({ viewModel: this.unitOfMeasurementService.editor });
    }

    addStandard() {
        this.dialogService.open({ viewModel: this.standardService.editor });
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.customerProject.id) {
                    await this.customerProjectService.update(this.customerProject);
                    toastr.success('Customer project was updated!');
                    this.ea.publish('customer-projects:updated', this.customerProject);
                    this.controller.ok(this.customerProject);
                } else {
                    let id = await this.customerProjectService.create(this.customerProject);
                    this.customerProject.id = id;
                    toastr.success('New customer project was created!');
                    this.ea.publish('customer-projects:updated', this.customerProject);
                    this.controller.ok(this.customerProject);
                }
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}
